import { mapState, mapActions } from 'pinia'
import { useLoaderStore } from '@/store/loaderStore'
import { useDynamicFormStore } from '@/store/dynamicFormStore.js'
import { useProjectStore } from '@/store/projectStore.js'
import { redirectToSuccess } from '@/shared/utils/getSuccessUrl'
import { useToastStore } from '@/store/toastStore'
import { ensureAuth } from '@/plugins/firebase'
import { mapFirebaseError } from '@/shared/utils/firebaseErrors'

export default {
  computed: {
    ...mapState(useProjectStore, ['project']),
    ...mapState(useLoaderStore, ['isLoading']),
    ...mapState(useDynamicFormStore, { dynamicFormTemplate: 'dataUser' }),
    ...mapState(useProjectStore, ['isProjectFree', 'productsExtraInForm']),
    $_inscriptionFormMixin_roles: () => ['fan', 'parent', 'player', 'manager'],
    $_inscriptionFormMixin_routesStatus: () => ['404', 'SoldOut', 'DeadLine', 'Closed', 'ConnectionError'],
    $_inscriptionFormMixin_actionPayingMustBePerformed: ({ isProjectFree, productsExtraInForm }) => !isProjectFree || productsExtraInForm.length > 0,
  },
  methods: {
    ...mapActions(useLoaderStore, ['show', 'hide', 'setIsLoading']),
    ...mapActions(useProjectStore, ['createEnrollmentAndPaymentItems']),
    ...mapActions(useToastStore, ['addToast']),
    async $_inscriptionFormMixin_handleEnroll({ playersForm, waiverForm = null }) {
      if (this.isLoading) {
        return
      }
      this.show()
      this.setIsLoading(true)
      try {
        // La sesión anónima puede haberse perdido desde que se cargó la página (#48).
        await ensureAuth()
        const { organizationId, projectId, globalForm: { parentForm, parentDynamicForm } } = this
        const { address } = parentForm || playersForm?.[0]?.playerForm || {}
        const formData = {
          ...(this.dynamicFormTemplate?.parentProfileFields && { parentForm: this.$_formMixin_parseParentForm({ parentForm, parentDynamicForm }) }),
          playerForm: this.$_formMixin_parsePlayerForm({ players: playersForm }),
          addressForm: this.$_formMixin_parseAddressForm({ address }),
          ...(waiverForm && { waiverForm }),
        }
        const { error } = await this.createEnrollmentAndPaymentItems({ formData, organizationId, projectId }) ?? {}
        if (error) {
          // No redirigir a éxito: la inscripción no se ha creado.
          this.$inscriptionFormMixin_showToastError(error)
          return
        }
        redirectToSuccess(this)
      } catch (err) {
        this.$inscriptionFormMixin_showToastError(this.$t(mapFirebaseError(err)))
      } finally {
        this.hide()
        this.setIsLoading(false)
      }
    },
    $inscriptionFormMixin_showToastError(errorMessage) {
      this.hide()
      this.addToast({
        message: errorMessage,
        type: 'error'
      })
      this.setIsLoading(false)
    },
    $_inscriptionFormMixin_getRoleUserByProject(user) {
      return user?.roles?.byProperty?.[this.organizationId]?.byProject?.[this.projectId]?.roles
        ?.find(role => this.$_inscriptionFormMixin_roles.includes(role))
    },
  },
}
